import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { mailingAPI } from "../api/api";
import { MailingActionTypes } from "../actions/actionTypes";

function* getMailingLists(action) {
    try {
        const mailingLists = yield call(() =>
            mailingAPI.getMailingLists({
                page: action.payload.page,
                top: action.payload.top,
                search: action.payload.search,
                subsidiaries: action.payload.subsidiaries,
                status: action.payload.status
            })
        );

        yield put({
            type: MailingActionTypes.GET_MAILING_LISTS_SUCCESS,
            payload: mailingLists.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Mailing Lists.");

        yield put({
            type: MailingActionTypes.GET_MAILING_LISTS_FAIL,
            message: e.message
        });
    }
}

export function* getMailingListsWatcher() {
    yield takeLatest(MailingActionTypes.GET_MAILING_LISTS, getMailingLists);
}

function* getMailingList(action) {
    try {
        const mailingList = yield call(() =>
            mailingAPI.getMailingList(action.payload.mailingID)
        );

        yield put({
            type: MailingActionTypes.GET_MAILING_LIST_SUCCESS,
            payload: mailingList.data.results[0]
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching Mailing List");

        yield put({
            type: MailingActionTypes.GET_MAILING_LIST_FAIL,
            payload: e
        });
    }
}

export function* getMailingListWatcher() {
    yield takeLatest(MailingActionTypes.GET_MAILING_LIST, getMailingList);
}
